<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">治疗师</span></div>
      <el-descriptions>
        <el-descriptions-item label="姓名">{{form.customerName || form.techInfoName}}</el-descriptions-item>
        <el-descriptions-item label="身份">{{form.customerLevel || form.techInfoLevel}}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{form.customerPho || form.techInfoPho}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">档案信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="姓名">{{form.name}}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{form.pho}}</el-descriptions-item>
        <el-descriptions-item label="性别">{{form.sex === 1?'男':'女'}}</el-descriptions-item>
        <!-- <el-descriptions-item label="OpenID">{{form.id}}</el-descriptions-item> -->
        <el-descriptions-item label="建档时间">{{form.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="治疗时长">{{form.therapyDuration}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">就诊记录</span></div>
      <div v-for="item in form.caseHistoryList" :key="item.id" class="treatment-box">
        <div class="tdesc w2">治疗时间：{{item.createdTime}}</div>
        <div class="tdesc w2">治疗状态：{{item.therapyStatus?'治疗结束':'治疗中'}}</div>
        <div class="tdesc w2">治疗次数：{{item.therapyNum}}</div>
        <div class="tdesc w2">治疗天数：{{item.therapyDuration}}</div>
        <div class="tdesc">病名: {{item.diseaseName}}</div>
        <div class="tdesc">描述: {{item.historySyndrome}}</div>
        <div class="tdesc">记录</div>
        <div class="record-item" v-for="(it,idx) in item.diagnosticLogoutList" :key="idx">治疗时间：{{it.createdTime}}  <span @click="handleShowRecord(it)">查看记录</span></div>
      </div>
    </el-card>
    <fileManageRecords ref="fileManageRecords" />
  </div>
</template>

<script>
import patientApi from '@/api/archives/patient'
import fileManageRecords from './records.vue'
export default {
  components: { fileManageRecords },
  props: ['rowItem',],
  data() {
    return {
      form: {},
    }
  },
  created() {
    this.getDeatils()
  },
  methods: {
    getDeatils() {
      patientApi.fetchById(this.rowItem.id).then(res => {
        let data = res;
        this.form = data
      })
    },
    handleShowRecord(item) {
      this.$refs.fileManageRecords.handleShow(item)
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
.treatment-box {
  background-color: #EEEDED;
  padding: 16px 28px;
  margin-bottom: 14px;
  .tdesc{
    font-size: 14px;
    color:#606266;
    padding-bottom: 12px;
    &.w2{
      width: 49%;
      display: inline-block;
    }
  }
  .record-item{
    font-size: 14px;
    color: #606266;
    padding: 12px 8px;
    background: #fff;
    margin-bottom: 5px;
    width: 480px;
    span{
      color: #4680E3;
      cursor: pointer;
      float: right;
    }
  }
}
</style>
